import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Subscription } from 'rxjs';
import { MessageContentCardComponent } from '../../../../../components/organization/campaigns/message-content-card/message-content-card.component';
import { CampaignsService } from '../../../../../services/campaign/campaigns-api.service';
import {
  CampaignInsightsService,
  MessageMeta,
} from '../../../../../services/campaign/campaign-insights.service';
import {
  CampaignDetails,
  EngagementMessage,
} from '../../types/campaignDetails';
import { CreateMessageComponent } from '../../../../../components/organization/campaigns/create-message/create-message.component';
import { orderedMessages, plural, schedulesOf } from '../campaign-sends';

/** Every message in the campaign, as recipients will read it, with its sends and delivery. */
@Component({
  selector: 'app-message-content',
  standalone: true,
  imports: [MessageContentCardComponent, CreateMessageComponent],
  templateUrl: './message-content.component.html',
  styleUrl: './message-content.component.css',
})
export class MessageContentComponent implements OnInit {
  private destroyRef = inject(DestroyRef);
  private insights = inject(CampaignInsightsService);
  campaignsService = inject(CampaignsService);
  messages: EngagementMessage[] = [];
  campaign!: CampaignDetails;
  createMessage = false;
  /** Each message's own details (uuid, sender, status) by id; the campaign leaves them out. */
  meta: Record<number, MessageMeta> = {};

  private metaKey = '';
  private metaSub?: Subscription;

  get loaded(): boolean {
    return !!this.campaign?.id;
  }

  get summary(): string {
    const sends = this.messages.reduce((total, message) => total + schedulesOf(message).length, 0);
    return `${plural(this.messages.length, 'message', 'messages')}, ${plural(sends, 'scheduled send', 'scheduled sends')}.`;
  }

  ngOnInit() {
    this.destroyRef.onDestroy(() => this.metaSub?.unsubscribe());

    //assign data to component campaign variable
    this.campaignsService.getCampaignDetails
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((data) => {
        this.campaign = data as CampaignDetails;
        // The API returns messages as an unordered set; show them in the order they were added.
        this.messages = orderedMessages(this.campaign);
        this.loadMeta();
      });
  }

  private loadMeta() {
    const ids = this.messages.map((message) => message.id);
    const key = ids.join(',');
    if (key === this.metaKey) return;
    this.metaKey = key;
    this.metaSub?.unsubscribe();
    this.metaSub = this.insights.messageMeta(ids).subscribe((meta) => (this.meta = meta));
  }
}
